import { Box, Tooltip, Button } from "@material-ui/core";
import { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { Loading } from "../../components/shared/loading";
import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";

import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";

const $ = require("jquery");

export const AllArticles = () => {
  const classes = useAdminStyles();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const formdata = new FormData();
    axios.post("/api/get_all_articles_bk", formdata).then((res) => {
      if (res.data.status === true) {
        setData(res.data.data || []);
        setLoading(false);
        $(document).ready(function () {
          $("#articles_table").DataTable({
            destroy: true,
            order: [[0, "desc"]],
          });
        });
      } else {
        setLoading(false);
      }
    });
  }, []);

  if (loading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>Articles - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="Manage"
        title="Articles"
        subtitle="Blog posts and news articles published on the public site."
        actions={
          <Button
            onClick={() => navigate("/dash/add_article")}
            className={classes.primaryBtn}
            startIcon={<AddIcon />}
          >
            Add Article
          </Button>
        }
      />

      <Box className={classes.tableWrap}>
        <table id="articles_table" className="display" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Image</th>
              <th>Status</th>
              <th>Published</th>
              <th>Updated</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((da) => (
              <tr key={da.article_id}>
                <td>{da.article_id}</td>
                <td style={{ fontWeight: 600, color: "#1a1a1a" }}>
                  {da.article_title}
                </td>
                <td>
                  {da.article_images ? (
                    <img
                      src={`/static/articles/${da.article_images.split(",")[0]}`}
                      alt={da.article_title}
                      style={{ height: 56, width: 80, objectFit: "cover" }}
                    />
                  ) : (
                    <span style={{ color: "#9ca3af", fontSize: "0.74rem" }}>
                      No image
                    </span>
                  )}
                </td>
                <td>
                  {da.article_status === 1 ? (
                    <span className={`${classes.badge} ${classes.badgeActive}`}>
                      <CheckCircleOutlineIcon /> Active
                    </span>
                  ) : (
                    <span className={`${classes.badge} ${classes.badgeInactive}`}>
                      <RemoveCircleOutlineIcon /> Inactive
                    </span>
                  )}
                </td>
                <td>{da.article_published_date || "-"}</td>
                <td>{da.article_updated_date || "-"}</td>
                <td>
                  <Box className={classes.actionCell}>
                    <Tooltip title="Edit" arrow>
                      <Link
                        to={`/dash/edit_articles/${da.article_id}`}
                        className={classes.iconBtn}
                        aria-label="Edit"
                      >
                        <EditOutlinedIcon />
                      </Link>
                    </Tooltip>
                  </Box>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </div>
  );
};
